import { render, staticRenderFns } from "./costBreakdownJB.vue?vue&type=template&id=4526e3ce&scoped=true&"
import script from "./costBreakdownJB.vue?vue&type=script&lang=js&"
export * from "./costBreakdownJB.vue?vue&type=script&lang=js&"
import style0 from "./costBreakdownJB.vue?vue&type=style&index=0&id=4526e3ce&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4526e3ce",
  null
  
)

export default component.exports